import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { ProductsComponent } from './products/products.component';
import { ServicesComponent } from './services/services.component';
import { CareersComponent } from './careers/careers.component';
import { AboutComponent } from './about/about.component';
import { ContactComponent } from './contact/contact.component';
import { ProductPOSComponent } from './product-pos/product-pos.component';
import { ProductLotteryComponent } from './product-lottery/product-lottery.component';
import { ProductBankingComponent } from './product-banking/product-banking.component';
import { AccountPayableComponent } from './account-payable/account-payable.component';
import { ServiceSupportComponent } from './service-support/service-support.component';
import { InventoryManagementComponent } from './inventory-management/inventory-management.component';
import { MarketingComponent } from './marketing/marketing.component';
import { UtilityBillingComponent } from './utility-billing/utility-billing.component';
import { ServiceMobileComponent } from './services/service-mobile/service-mobile.component';
import { ServiceCloudsolutionComponent } from './services/service-cloudsolution/service-cloudsolution.component';
import { ServiceCustomsoftwareComponent } from './services/service-customsoftware/service-customsoftware.component';
import { ServiceDatabasesolutionComponent } from './services/service-databasesolution/service-databasesolution.component';
import { ServiceTestingComponent } from './services/service-testing/service-testing.component';
import { ServiceWebComponent } from './services/service-web/service-web.component';
import { BlogComponent } from './blog/blog.component';
import { BlockchainTechnologyComponent } from './blockchain-technology/blockchain-technology.component';
import { QuantumComputingComponent } from './quantum-computing/quantum-computing.component';
import { WhatIsMobileApplicationComponent } from './what-is-mobile-application/what-is-mobile-application.component';
import { IOSDevelopmentComponent } from './ios-development/ios-development.component';
import { WebAppDevelopmentComponent } from './web-app-development/web-app-development.component';
import { ApplicationDevelopmentProgrammingComponent } from './application-development-programming/application-development-programming.component';
import { DatabaseDevelopmentComponent } from './database-development/database-development.component';
import { SoftwaredevelopmentComponent } from './softwaredevelopment/softwaredevelopment.component';
import { CloudComputingComponent } from './cloud-computing/cloud-computing.component';
import { CustomBuildSoftwareDevelopmentComponent } from './custom-build-software-development/custom-build-software-development.component';


const routes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: 'home', component: HomeComponent },
  { path: 'products', component: ProductsComponent },
  { path: 'services', component: ServicesComponent },
  { path: 'careers', component: CareersComponent },
  { path: 'about-us', component: AboutComponent },
  { path: 'contact-us', component: ContactComponent },
  { path: 'retail-pos-system', component: ProductPOSComponent },
  { path: 'banking', component: ProductBankingComponent },
  { path: 'account-payable-software', component: AccountPayableComponent },
  { path: 'service-support', component: ServiceSupportComponent },
  { path: 'lottery-management-software', component: ProductLotteryComponent },
  { path: 'utility-billing', component: UtilityBillingComponent },
  { path: 'inventory-management', component: InventoryManagementComponent },
  { path: 'marketing-management', component: MarketingComponent },
  //new code added by Digvijay on 18-06-2019
  { path: 'service-mobile', component: ServiceMobileComponent },
  { path: 'service-cloudsolution', component: ServiceCloudsolutionComponent },
  { path: 'service-customsoftware', component: ServiceCustomsoftwareComponent },
  { path: 'service-databasesolution', component: ServiceDatabasesolutionComponent },
  { path: 'service-testing', component: ServiceTestingComponent },
  { path: 'service-web', component: ServiceWebComponent },
  { path: 'blog', component: BlogComponent  },
  { path: 'blockchain-technology', component: BlockchainTechnologyComponent  },
  { path: 'quantum-computing', component: QuantumComputingComponent  },
  { path: 'what-is-mobile-application', component: WhatIsMobileApplicationComponent  },
  { path: 'ios-development', component: IOSDevelopmentComponent  },
  { path: 'web-app-development', component: WebAppDevelopmentComponent  },
  { path: 'application-development-programming', component: ApplicationDevelopmentProgrammingComponent  },
  { path: 'database-development', component: DatabaseDevelopmentComponent  },
  { path: 'softwaredevelopment', component: SoftwaredevelopmentComponent  },
  { path: 'CloudComputing', component: CloudComputingComponent  },
  { path: 'CustomBuildSoftwareDevelopment', component: CustomBuildSoftwareDevelopmentComponent  },
  //end code on 18-06-2019
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {scrollPositionRestoration: 'enabled'})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
